export type RouteKey = 'register' | 'login' | 'dashboard' | 'userProfile' | 'userCourses' | 'region' | 'regionSelect';

type RouteConfig = {
    url: string,
}

type Routes = Record<RouteKey, RouteConfig>;

const routes: Routes = {
    register: { url: '/registrierung' },
    login: { url: '/login' },
    // loginRegister: { url: '/login-registrierung' },
    dashboard: { url: '/dashboard.html' },
    userProfile: { url: '/mein-trainings-guthaben-buggyfit' },
    userCourses: { url: '/meine-kurse' },
    region: { url: '/standorte/{slug}' },
    regionSelect: { url: '/standorte' },
};

const registerRedirect: RouteKey = 'userProfile';
const loginRedirect: RouteKey = 'userProfile';
const logoutRedirect: RouteKey = 'login';
const missingAuth: RouteKey = 'login';
const forbiddenAuth: RouteKey = 'userProfile';

/*
export function getUrl(routeKey: RouteKey, parameters?: Record<string, string|number>) {
    let url = routes[routeKey].url;

    if( !parameters ) {
        return url;
    }

    Object.entries(parameters).forEach(([key, value]) => {
        url = url.replaceAll('{'+key+'}', value + '');
    });

    return url;
}
*/

export default {
    routes,
    registerRedirect,
    loginRedirect,
    logoutRedirect,
    missingAuth,
    forbiddenAuth,
};
